import { TextResources, ConfigData } from '../config/StoreLocatorTextResources';
import { LOCATIONCOMPONENT } from './location.component';
import { LOCALSTORAGE } from '../services/local.storage.service';
import { URLSERVICE } from '../services/url.service';

export class OrderAtHomeComponent {
  createOrderAtHomeButton(element) {
    const orderathomeB2BJsonElement = LOCATIONCOMPONENT.getOrderathomeUrlJsonElement();
    const currenLocationData = LOCATIONCOMPONENT.getCurrentLocationData(element.id);
    // console.log('currenLocationData: ', currenLocationData);

    if (orderathomeB2BJsonElement) {
      const jsonContetnt = LOCATIONCOMPONENT.getJsonContent(orderathomeB2BJsonElement);
      const orderAtHomeURL = URLSERVICE.getOrderAtHomeURLB2B(currenLocationData.keyacc_id, jsonContetnt);
      ConfigData.data['urlOrderAtHomePage'] = orderAtHomeURL;
    }
    if (
      ConfigData.data['urlOrderAtHomePage'] &&
      (ConfigData.data['showOrderAtHomeButton'] || ConfigData.data['showGetDirectionsButton'])
    ) {
      const orderAtHomeHTMLElement: HTMLElement = element.querySelector('cwc-order-at-home');

      if (!orderAtHomeHTMLElement.hasChildNodes()) {
        if (ConfigData.data['showOrderAtHomeButton']) {
          const orderAtHomeLink = `${URLSERVICE.getOrderAtHomeURL()}#/printsOrder;locationId=${element.id};articleIds=%5B${currenLocationData['onsite_prints']}%5D`;
          const orderAtHomeButton = this.createButton(orderAtHomeLink, 'order_now', currenLocationData);

          orderAtHomeHTMLElement.appendChild(orderAtHomeButton);
        }

        if (ConfigData.data['showGetDirectionsButton']) {
          const searchQuery = `${currenLocationData['name'].replace(/[0-9]/g, '')},${currenLocationData['zip']},${currenLocationData['city']},${currenLocationData['street']}`;
          const directionsLink = `https://www.google.com/maps/search/?api=1&query=${searchQuery}`;
          const directionsButton = this.createButton(directionsLink, 'get_directions');

          orderAtHomeHTMLElement.appendChild(directionsButton);
        }
      }
    }
  }

  createButton(url: string, type: string, currenLocationData?: object) {
    const button = document.createElement('button');
    button.type = 'button';

    if (type === 'get_directions') {
      button.className = 'sg-cw-button sg-cw-raise sg-cw-raise-secondary';
    } else {
      button.className = 'sg-cw-button sg-cw-raise';
    }
    button.textContent = TextResources.resources['location'].control[type];
    button.addEventListener('click', () => {
      LOCALSTORAGE.addLocationKeyToLocalStorage(currenLocationData);
      window.location.href = url;
    });
    return button;
  }
}

export const ORDERATHOME = new OrderAtHomeComponent();
